// Order in the UI depends on the order of the enum
export enum CheckoutStatus {
  DefaultAndAbTestRunning,
  Default,
  LiveAbTestSegmented,
  LiveSegmented,
  AbTest,
  AbTestSegmented,
  DisabledSegmented,
  Disabled,
}
